import { render, staticRenderFns } from "./configPayrollSteward.vue?vue&type=template&id=311866f5&scoped=true"
import script from "./configPayrollSteward.vue?vue&type=script&lang=js"
export * from "./configPayrollSteward.vue?vue&type=script&lang=js"
import style0 from "./configPayrollSteward.vue?vue&type=style&index=0&id=311866f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311866f5",
  null
  
)

export default component.exports